const opened = ({ layout }) => layout?.sidebar?.open;

export { opened };
